import React, { useContext } from "react";
import { TranslationContext } from "../../context/translations/translations-context";

export default function CommonChipItem( { chip, handleRemove } ) {
    const { displayLanguage } = useContext( TranslationContext );

    return (
        <div className="chip">
            { chip.labels?.[ displayLanguage ] || chip.label }
            <span className="chip-close" onClick={ () => handleRemove( chip ) }>×</span>
        </div>
    );
}
